export default {
  get(key){
    if (!key) {
      key = this.keyDefault;
    }
    return JSON.parse(sessionStorage.getItem(key) || "{}");
  },
  set(optionObject, key){
    this.append(optionObject, key)
  },
  append(optionObject, key) {
    if (!key) {
      key = this.keyDefault;
    }
    let temp = this.get(key);
    temp = Object.assign(temp, optionObject)
    sessionStorage.setItem(key, JSON.stringify(temp));
  },
  remove(key) {
    sessionStorage.removeItem(key);
  },
  keyDefault: "mogo_h5"
};



// WEBPACK FOOTER //
// ./src/library/sessionStorageUtil.js